import { TransformableItem, TransformableItemProperties, ItemProperties } from './Item';
import { Field, PanelId } from './Field';

/**
 * Light type
 */
export type LightType = 'point' | 'spot' | 'directional' | 'ambient';

/**
 * Light fields
 */
export const LightFields: Field[] = [
  {
    key: 'properties.color',
    type: 'color',
    label: 'Color',
    default: '#ffffff',
    panel: 'light',
  },
  {
    key: 'properties.intensity',
    type: 'number',
    label: 'Intensity',
    default: 1,
    panel: 'light',
  },
];

/**
 * Light properties
 */
export interface LightProperties extends TransformableItemProperties {
  color: string;
  intensity: number;
  castShadow?: boolean;
  // Spot light specific
  angle?: number;
  penumbra?: number;
  // Shadow properties
  shadowBias?: number;
  shadowRadius?: number;
  shadowMapSize?: { width: number; height: number };
}

/**
 * Light item interface
 * 
 * @property type - The type of item
 * @property subtype - The subtype of the light
 * @property properties - The properties of the light
 */
export interface Light<P extends LightProperties = LightProperties> extends TransformableItem<P> {
  type: 'light';
  subtype: string;
  properties: P;
} 